export const homeDeliveryInfoAdapter = (data) => {

	const order0 = data?.order?.[0] || {};
	const info = order0.info || {};
	const infoDelivery = info.info_delivery || {};
	const country = data?.tracking?.[0]?.country;

	const streetRaw = (infoDelivery.street || '').toString().trim();
	const streetNumber = (infoDelivery.street_number || '').toString().trim();

	let street = streetRaw;

	if (country === 'CLNARMA' || country === 'CLGREEN' || country === 'CLANICX' || country === 'CLZUPHARMA') {
		if (streetNumber) {
			const escapedNumber = streetNumber.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
			const regex = new RegExp(`\\b${escapedNumber}\\b`);
			if (!regex.test(streetRaw)) {
				street = `${streetRaw} ${streetNumber}`.trim();
			} else {
				street = streetRaw;
			}
		} else {
			street = streetRaw;
		}
	} else {
		street = streetRaw;
	}

	return [
		{
			key: order0._id,
			type_house: infoDelivery.type_house || '-',
			phone: info.phone || '-',
			reference: infoDelivery.reference || '-',
			street,
			commune: infoDelivery.commune || '-',
			region: country === 'CLNARMA' || country === 'CLGREEN' || country === 'CLANICX' || country === 'CLZUPHARMA' ? infoDelivery.region : infoDelivery.province,
			dpto: infoDelivery.number_dpto_house || '-',
			zip_code: infoDelivery.zip_code || '-',
			municipality: infoDelivery.municipality || '-'
		},
	];
};